/**
 * Available Timeline layout orientation
 * @public
 */
enum TimelineLayout {
	/**
	 * Vertical layout
	 * Default type
	 * @public
	 */
	Vertical= "Vertical",

	/**
	 * Horizontal layout
	 * @public
	 */
	Horizontal= "Horizontal",
}

export default TimelineLayout;
